module.exports = __webpack_public_path__ + "static/media/selected_2x.fffe5cfa.png";